import { supabase } from '@/lib/supabase';
import { OrganizationCategory } from '@/shared/types/api';

export const getOrganizationCategories = async (): Promise<
  OrganizationCategory[]
> => {
  const { data, error } = await supabase
    .from('organization_categories')
    .select('id, parent_id')
    .order('id');

  if (error) {
    throw error;
  }

  return data;
};

// Helper functions to filter on the frontend
export const getMainCategories = (
  categories: OrganizationCategory[],
): string[] => {
  return categories
    .filter((category) => category.parent_id === null)
    .map((category) => category.id);
};

export const getSubcategories = (
  categories: OrganizationCategory[],
  categoryId: string,
): string[] => {
  return categories
    .filter((category) => category.parent_id === categoryId)
    .map((category) => category.id);
};
